import { registerFeature } from "lib/features"

import { FEATURE_FLAG_MOVE_SCHEDULES } from "routes/sfg20-admin/plugins/client-migration-tab/plugins/move-schedules/feature-flag-move-schedules.mjs"
import { MoveSchedulesToOtherClient } from "routes/sfg20-admin/plugins/client-migration-tab/plugins/move-schedules/move-schedules-to-other-client"
import { registerTab } from "lib/@components/tabs"
import { isEnabled } from "lib/@components/feature"

registerFeature({
    numericalId: 1002,
    name: "Move Schedules",
    id: FEATURE_FLAG_MOVE_SCHEDULES,
    description: `Enables user to move schedules to a different client`,
    readyForBeta: false,
    readyForProduction: false,
    internalUseOnly: true,
})

registerTab({
    tab: "sfg20AdminTabs",
    id: "scheduleMigration",
    title: "Schedule Migration",
    demands: ["admin-clientmigration", "$professional-services"],
    predicate: () => isEnabled(FEATURE_FLAG_MOVE_SCHEDULES),
    content: <MoveSchedulesToOtherClient $lazy />,
})
